export default "__VITE_PUBLIC_ASSET__d7a13249__"